export function findObjectsWithSameNumber(arr) {
    const numberMap = {};
    const duplicates = [];

    arr?.forEach((obj) => {
        const { number } = obj;
        if (numberMap[number]) {
            duplicates.push(obj);
        } else {
            numberMap[number] = [obj];
        }
    });

    return duplicates;
}

// Numbers can now be up to 19 digits, which exceeds Number.MAX_SAFE_INTEGER
// (16 digits) - use BigInt so arithmetic on the digit string doesn't lose precision.
function toSafeBigInt(number) {
    if (number === undefined || number === null) return null;
    const cleanNumber = String(number).startsWith('+')
        ? String(number).substring(1)
        : String(number);

    if (!/^\d+$/.test(cleanNumber)) return null;

    return BigInt(cleanNumber);
}

export function calculateLastNumber(number, blockSize) {
    if (!number) return '';

    const cleanNumber = number?.startsWith('+') ? number.substring(1) : number;
    const firstNum = toSafeBigInt(cleanNumber);

    if (firstNum === null || !Number.isInteger(blockSize)) return null;

    const lastNum = firstNum + BigInt(blockSize - 1);

    // Preserve leading zeros by padding to match original length
    const resultStr = lastNum.toString();
    const originalLength = cleanNumber.length;

    // Pad with leading zeros if the result is shorter than the original
    if (resultStr.length < originalLength) {
        return resultStr.padStart(originalLength, '0');
    }

    return resultStr;
}

export function validateBlockSizeRanges(items) {
    for (let i = 0; i < items.length - 1; i++) {
        for (let j = i + 1; j < items.length; j++) {
            const itemA = items[i];
            const itemB = items[j];

            const startA = toSafeBigInt(itemA.number);
            const startB = toSafeBigInt(itemB.number);

            if (startA === null || startB === null) continue;

            const rangeA = {
                start: startA,
                end: startA + BigInt(itemA.blockSize) - 1n,
            };
            const rangeB = {
                start: startB,
                end: startB + BigInt(itemB.blockSize) - 1n,
            };

            if (
                (rangeA.start <= rangeB.end && rangeA.end >= rangeB.start) ||
                (rangeB.start <= rangeA.end && rangeB.end >= rangeA.start)
            ) {
                return true;
            }
        }
    }
    return false;
}
